import { Dialog } from '@bloomfieldrobotics/canopy';
import { DialogContent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import {
  selectIsOpenBlockBoundaryDialog,
  setIsOpenBlockBoundaryDialog,
} from '../../onboardingSlice';
import BlockBoundaryForm from './BlockBoundaryForm';

const BlockBoundaryOnboardDialog: React.FC = () => {
  const { t } = useTranslation();
  const isOpenBlockBoundaryDialog = useAppSelector(
    selectIsOpenBlockBoundaryDialog
  );
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setIsOpenBlockBoundaryDialog(false));
  };

  return (
    <Dialog
      title={t('Block Boundary Onboarding', { ns: 'common' })}
      open={isOpenBlockBoundaryDialog}
      onClose={handleClose}
      fullWidth
    >
      <DialogContent>
        <BlockBoundaryForm />
      </DialogContent>
    </Dialog>
  );
};

export default BlockBoundaryOnboardDialog;
